import { BaseApi as Base } from '@micromag/data';

class OrganisationsMembersApi extends Base {
    find(organisation, id) {
        return this.requestGet(
            this.route('organisations.members.show', {
                organisation,
                member: id,
            }),
        );
    }

    findByUser(organisation, id) {
        return this.get(organisation, {
            user: id,
        }).then((items) => (items !== null && items.length > 0 ? items[0] : null));
    }

    get(organisation, query) {
        return this.requestGet(
            this.route('organisations.members.index', {
                organisation,
            }),
            query,
        );
    }

    create(organisation, data) {
        return this.requestPost(
            this.route('organisations.members.store', {
                organisation,
            }),
            data,
        );
    }

    batch(organisation, data) {
        return this.requestPost(
            this.route('organisations.members.batch', {
                organisation,
            }),
            data,
        );
    }

    update(organisation, member, data) {
        return this.requestPut(
            this.route('organisations.members.update', {
                organisation,
                member,
            }),
            data,
        );
    }

    delete(organisation, member) {
        return this.requestDelete(this.route('organisations.members.destroy', { organisation, member }));
    }
}

export default OrganisationsMembersApi;
